<template>
  <div>
    <input-combobox ref="campo"
    placeholder="Selecione"
    v-bind="$attrs"
    v-model="select"
    :options="items"
    @change="changeSelect"
    :clearable="$attrs.clearable !== undefined? $attrs.clearable : true">
      <template slot="selection">
        <slot name="selection" v-bind="{date: model, value: select}">
          {{$api.UI.Format.Date(model, format)}}
        </slot>
      </template>
      <template slot="append-outer">
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"

            full-width
            max-width="290px"
            min-width="290px"
            data-cy="menu-dateselect">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-on="on" v-bind="attrs">mdi-calendar</v-icon>
          </template>
            <v-date-picker
              :active-picker.sync="activePicker"
              v-bind="$attrs"
              no-title
              :max="max"
              ref="picker"
              locale="pt-br"
              v-model="model"
              @input="menu = false"
              :data-cy="$attrs.label || $attrs.name">
            </v-date-picker>
        </v-menu>
      </template>
    </input-combobox>
  </div>
</template>
<script>
export default {
  props: {
    value: null,
    items: { Type: Array },
    format: { default: 'dd/MM/yyyy' },
    max: { default: new Date().toISOString().substr(0, 10) },
    tipo: { default: 'diario' }
  },
  data: () => ({
    menu: false,
    activePicker: null
  }),
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    changeSelect (val) {
      this.$set(this, 'model', val ? this.$api.UI.Date.AddDay(this.$attrs.min || new Date(), (val)).toISOString().substr(0, 10) : '')
    },
    validar () {}
  },
  computed: {
    model: {
      get () {
        if (this.value && ['string', 'date'].includes(typeof this.value)) {
          var val = new Date(Date.parse(this.value)).toISOString().substr(0, 10)
          return val
        }
        return this.value
      },
      set (val) {
        if (val) {
          this.$emit('input', new Date(Date.parse(val)).toISOString().substr(0, 10))
        } else {
          this.$emit('input', null)
        }
      }
    },
    select: {
      get () {
        if (this.model) { return this.$api.UI.Date.DaysBetween(this.$attrs.min || new Date(), this.model) } else { return null }
      },
      set () {
      }
    }
  },
  watch: {
    menu (val) {
      if (this.$attrs.anual === '') { val && setTimeout(() => (this.activePicker = 'YEAR')) }

      switch (this.tipo) {
        case 'anual':
          val && setTimeout(() => (this.activePicker = 'YEAR'))
          break
        default:
          break
      }
    },
  },
  mounted () {
    if (this.$refs.campo) {
      const el = this.$refs.campo.$el
      el.querySelector('input').setAttribute('readonly', true)
    }
  }
}
</script>
